module.exports = __webpack_public_path__ + "static/media/arrow-right.2f3474f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-right.svg
// module id = 83
// module chunks = 0